import { useEffect } from "react";
import { db } from "../../firebase/config";
import { useDispatch, useSelector } from "react-redux";
import { TalesFaq } from "../types/TalesFaq";
import { setFaqData } from "../../store/faq/actions/setData";
import { setFaqError } from "../../store/faq/actions/setError";
import { addUsedHook } from "../../store/site/actions/addUsedHook";
import { usedHooks } from "../../store/site/selectors";

export default function useFaqs() {
  const dispatch = useDispatch();
  const hooks = useSelector(usedHooks);

  useEffect(() => {
    if (!hooks.includes("useFaqs")) {
      dispatch(addUsedHook("useFaqs"));
      db.collection("faq").onSnapshot((snapshot) => {
        if (snapshot.empty) {
          dispatch(setFaqError("Non è stata trovato nessuna FAQ"));
        } else {
          let faqs: TalesFaq[] = [];
          snapshot.docs.forEach((doc) => {
            faqs = [...faqs, doc.data() as TalesFaq];
          });
          dispatch(setFaqData(faqs));
        }
      });
    }
  }, [dispatch, hooks]);
}
